import React from 'react';
import './about.css';
import ME from '../../assets/me-about_alt.webp';
import logoBTS from '../../assets/formation/logoBTS.webp';
import logoINA from '../../assets/formation/logoINA.webp';
import logoENJMIN from '../../assets/formation/logoENJMIN.webp';
import fmodLOGO from '../../assets/logiciels/fmodLOGO.svg';
import abletonLOGO from '../../assets/logiciels/abletonLOGO.svg';
import nuendoLOGO from '../../assets/logiciels/nuendoLOGO.svg';
import protoolsLOGO from '../../assets/logiciels/protoolsLOGO.svg';
import reaperLOGO from '../../assets/logiciels/reaperLOGO.svg';
import unityLOGO from '../../assets/logiciels/unityLOGO.svg';
import wwiseLOGO from '../../assets/logiciels/wwiseLOGO.svg';
import unrealLOGO from '../../assets/logiciels/unrealLOGO.svg';
import LazyImage from '../../LazyImage';
import { useTranslation } from '../../contexts/TranslationContext';

const About = () => {
  const { t } = useTranslation();

  return (
    <section id='about'>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <LazyImage src={ME} alt="Tanguy" />
          </div>
          <div className="software-section">
            <li className="software-titletext">
              <div>{t('about.softwares')}</div>
            </li>
            <li className="software-item" data-software="Ableton">
              <LazyImage className="software-image" src={abletonLOGO} alt="" />
              <div className="text"></div>
            </li>
            <li className="software-item" data-software="Nuendo">
             <LazyImage className="software-image" src={nuendoLOGO} alt="" />
              <div className="text"></div>
            </li>
            <li className="software-item" data-software="Pro Tools">
              <LazyImage className="software-image" src={protoolsLOGO} alt="" />
              <div className="text"></div>
            </li>
            <li className="software-item" data-software="Reaper">
              <LazyImage className="software-image" src={reaperLOGO} alt="" />
              <div className="text"></div>
            </li>
            <li className="software-item" data-software="Wwise">
              <LazyImage className="software-image" src={wwiseLOGO} alt="" />
              <div className="text"></div>
            </li>
            <li className="software-item" data-software="FMOD">
              <LazyImage className="software-image" src={fmodLOGO} alt="" />
              <div className="text"></div>
            </li>
            <li className="software-item" data-software="Unity">
              <LazyImage className="software-image" src={unityLOGO} alt="" />
              <div className="text"></div>
            </li>
            <li className="software-item" data-software="Unreal Engine">
              <LazyImage className="software-image" src={unrealLOGO} alt="" />
              <div className="text"></div>
            </li>
          </div>
          <div className="training-section">
            <li className="training-titletext">
              <div>{t('about.trainings')}</div>
            </li>

            <li className="training-item" data-formation={t('about.bts.title')}>
              <a href={'//www.facebook.com/bts.audiovisuel.cannes'} target="_blank" rel="noreferrer">
                <LazyImage className="training-image" src={logoBTS} alt="BTS Audiovisuel" />
                <div className="training_content">
                  <p dangerouslySetInnerHTML={{ __html: t('about.bts.description') }}></p>
                </div>
              </a>
            </li>

            <li className="training-item" data-formation={t('about.license.title')}>
              <a href={'//www.ina-expert.com/licence-et-diplome-ina/diplome-ina-ingenierie-sonore-specialite-audiovisuel.html'} target="_blank" rel="noreferrer">
                <LazyImage className="training-image" src={logoINA} alt="Licence Pro - Ingénierie Sonore" />
                <div className="training_content">
                  <p dangerouslySetInnerHTML={{ __html: t('about.license.description') }}></p>
                </div>
              </a>
            </li>

            <li className="training-item" data-formation={t('about.master.title')}>
              <a href={'//enjmin.cnam.fr/formations/master-jeux-video/master-jeux-et-medias-interactifs-numeriques-1026151.kjsp'} target="_blank" rel="noreferrer">
                <LazyImage className="training-image" src={logoENJMIN} alt="Master JMIN - Conception Sonore" />
                <div className="training_content">
                  <p dangerouslySetInnerHTML={{ __html: t('about.master.description') }}></p>
                </div>
              </a>
            </li>
          </div>
        </div>

        <div className="about__content">
          <h2>{t('about.title')}</h2><br />
          <p dangerouslySetInnerHTML={{ __html: t('about.bio1') }} />
          <br /><br />
          <p dangerouslySetInnerHTML={{ __html: t('about.bio2') }} />
          <br /><br />
          <p dangerouslySetInnerHTML={{ __html: t('about.bio3') }} />
          <br /><br />
          <p dangerouslySetInnerHTML={{ __html: t('about.bio4') }} />
          <br /><br />
          <p dangerouslySetInnerHTML={{ __html: t('about.bio5') }} />
          <br /><br />
          <p dangerouslySetInnerHTML={{ __html: t('about.bio6') }} />
          <br /><br />
          <p dangerouslySetInnerHTML={{ __html: t('about.bio7') }} />
        </div>
      </div>
    </section>
  )
}

export default About;